module.exports = __webpack_public_path__ + "static/media/cdi.c0e77675.svg";